import { Autocomplete, Box, Grid, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Card, CardContent, Typography, Skeleton } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import OpenInFullIcon from '@mui/icons-material/OpenInFull'
import PieChartOutlineIcon from "@mui/icons-material/PieChartOutline";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { getRequest } from '../../globalhelper/helper'
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";

import { useSelector, useDispatch } from 'react-redux';
import { setExpenseData } from '../../redux/Dashboard/dashboardActions';
import moment from 'moment'

const ExpenseDashboard = ({ open, setOpen, company, globalFromDate, globalToDate, globalPeId }) => {
  const dispatch = useDispatch();
  const { expense } = useSelector((state) => state.dashboard);
  const [PeIDs, setPEIds] = useState(null);
  const [peId, setPeid] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!company?.orgid) return;
    let isMounted = true;
    getRequest(`api/dashboard/getIP2?orgid=${company?.orgid}`)
      .then(({ res }) => {
        if (!isMounted) return;
        const parsed = JSON.parse(res.data || "[]");

        const sorted = parsed.sort((a, b) => {
          const aVal = a?.["IP Number"] ?? "";
          const bVal = b?.["IP Number"] ?? "";
          return aVal.localeCompare(bVal);
        });

        setPEIds(sorted);
      })
      .catch((error) => console.log(error));
    return () => {
      isMounted = false;
    };
  }, [company]);

  useEffect(() => {
    if (!company?.orgid) return;
    let isMounted = true;
    console.log(peId);

    // Prioritize local state only if dialog is open
    const effectiveFromDate = open ? fromDate : globalFromDate;
    const effectiveToDate = open ? toDate : globalToDate;
    const effectivePeId = open ? peId : globalPeId;

    const formattedFromDate = effectiveFromDate ? effectiveFromDate.format("DD-MM-YYYY") : "";
    const formattedToDate = effectiveToDate ? effectiveToDate.format("DD-MM-YYYY") : "";

    setLoading(true);
    getRequest(
      `api/dashboard/getItemExpenses?orgid=${company?.orgid}&peId=${effectivePeId?.["IP Number"] || ""}&fromDate=${formattedFromDate}&toDate=${formattedToDate}`,
    )
      .then(({ res }) => {
        if (!isMounted) return;
        const parsed = JSON.parse(res.data || "[]").map((item) => ({
          name: item.account_class,
          Expense: parseFloat(item.total_goods_receipt) || 0,
          Percentage: parseFloat(item.percent_goods_receipt) || 0
        }));

        console.log(parsed, "Expense");

        dispatch(setExpenseData(parsed));
      })
      .catch((error) => console.log(error))
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, [company, peId, fromDate, toDate, globalFromDate, globalToDate, globalPeId, open]);

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <Box
          sx={{
            bgcolor: "rgba(255, 255, 255, 0.94)",
            p: 1,
            border: "1px solid #f1f5f9",
            borderRadius: 2,
            boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
            backdropFilter: "blur(4px)",
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.8, color: "#475569", fontSize: "0.8rem" }}>
            {label}
          </Typography>
          {payload.map((entry, index) => (
            <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.3 }}>
              <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: entry.fill }} />
              <Typography variant="caption" sx={{ color: "#475569", fontWeight: 500, fontSize: "0.7rem" }}>
                {entry.name}:
              </Typography>
              <Typography variant="caption" sx={{ color: "#475569", fontWeight: 700, fontSize: "0.7rem" }}>
                {entry.name === 'Expense' && typeof entry.value === 'number'
                  ? (entry.value >= 1000 ? `${(entry.value / 1000).toFixed(1)}k` : entry.value.toLocaleString("en-IN"))
                  : (typeof entry.value === 'number' ? entry.value.toLocaleString("en-IN") : entry.value)}
              </Typography>
            </Box>
          ))}
        </Box>
      );
    }
    return null;
  };

  const CustomizedAxisTick = (props) => {
    const { x, y, payload } = props;
    const text = payload.value;

    if (!open) {
      const displayedText = text.length > 15 ? text.slice(0, 15) + "..." : text;
      return (
        <g transform={`translate(${x},${y})`}>
          <text x={0} y={0} dy={16} textAnchor="end" fill="#475569" transform="rotate(-45)" fontSize={11} fontWeight={700}>
            {displayedText}
          </text>
        </g>
      );
    }

    const words = text.split(" ");
    const lines = [];
    let currentLine = "";
    words.forEach(word => {
      if ((currentLine + word).length > 15) {
        if (currentLine) lines.push(currentLine.trim());
        currentLine = word + " ";
      } else {
        currentLine += word + " ";
      }
    });
    if (currentLine) lines.push(currentLine.trim());

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor="end" fill="#475569" transform="rotate(-45)" fontSize={open ? 14 : 11} fontWeight={700}>
          {lines.map((line, i) => (
            <tspan key={i} x={0} dy={i === 0 ? 0 : "1.1em"}>{line}</tspan>
          ))}
        </text>
      </g>
    );
  };

  return (
    <Card sx={{
      height: open ? "85vh" : 500,
      minHeight: open ? "85vh" : 500,
      borderRadius: 4,
      boxShadow: "0 4px 20px rgba(0,0,0,0.03)",
      border: "1px solid #f1f5f9",
      transition: "box-shadow 0.3s ease",
      "&:hover": {
        boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
      }
    }}>
      <CardContent sx={{ height: "100%", display: "flex", flexDirection: "column", p: 3 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, color: "#475569", fontSize: "1.1rem", display: "flex", alignItems: "center", gap: 1 }}>
            <Box sx={{ p: 0.8, bgcolor: "#fff7ed", borderRadius: 2, display: "flex" }}>
              <AccountBalanceWalletIcon sx={{ color: "#f97316", fontSize: "1.2rem" }} />
            </Box>
            Expense Breakdown
          </Typography>
          {!open && <IconButton onClick={() => setOpen((prev) => ({ ...prev, expense: !prev.expense }))}><OpenInFullIcon /></IconButton>}
        </Box>
        {open && (
          <Grid container spacing={2} mb={1.5}>
            <Grid item xs={12} sm={4}>
              <Autocomplete
                size="small"
                fullWidth
                value={peId || null}
                options={PeIDs || []}
                getOptionLabel={(option) => option?.["costcentre"] || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.["IP Number"] === value?.["IP Number"]
                }
                onChange={(event, newValue) => setPeid(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Project"
                    variant="outlined"
                    name="PeId"
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                  />
                )}
              />
            </Grid>
          </Grid>
        )}
        <Box
          sx={{
            flexGrow: 1,
            minHeight: 0,
            mt: 1,
            p: 1.5,
            border: "1px solid #f1f5f9",
            borderRadius: 3,
            bgcolor: "#fcfdfe",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {loading ? (
            <Box sx={{ height: "100%", width: "100%", display: "flex", flexDirection: "column", gap: 2, p: 2 }}>
              <Skeleton variant="rectangular" width="100%" height={open ? 550 : 350} sx={{ borderRadius: 3 }} />
              <Box sx={{ display: "flex", justifyContent: "center", gap: 3 }}>
                <Skeleton width={100} height={20} />
                <Skeleton width={100} height={20} />
              </Box>
            </Box>
          ) : expense?.reports?.length > 0 ? (
            <Box sx={{ overflowX: "auto", overflowY: "hidden", width: "100%", height: "100%", pb: 1 }}>
              <Box sx={{ height: open ? 550 : 350, minWidth: Math.max(400, (expense?.reports?.length || 0) * 70) }}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    layout="horizontal"
                    data={expense?.reports}
                    margin={{ top: 20, right: 20, left: 10, bottom: open ? 120 : 40 }}
                    barCategoryGap={16}
                  >
                    <CartesianGrid strokeDasharray="10 4" vertical={false} />

                    <XAxis
                      dataKey="name"
                      interval={0}
                      tick={<CustomizedAxisTick />}
                      height={open ? 120 : 50}
                    />

                    <YAxis
                      yAxisId="expense"
                      type="number"
                      allowDecimals={false}
                      domain={[0, "dataMax + 5"]}
                      tick={{ fontSize: open ? 14 : 10, fill: "#334155", fontWeight: 600 }}
                      width={open ? 70 : 50}
                      tickFormatter={(v) => v >= 1000 ? `${(v / 1000).toFixed(1)}k` : v}
                    />

                    <YAxis
                      yAxisId="percentage"
                      type="number"
                      orientation="right"
                      domain={[0, 100]}
                      hide
                    />

                    <Tooltip content={<CustomTooltip />} />
                    <Legend verticalAlign="top" height={open ? 48 : 36} wrapperStyle={{ fontSize: open ? '1.1rem' : '0.85rem', fontWeight: 600, color: "#475569" }} />

                    {/* EXPENSE BAR */}
                    <Bar
                      yAxisId="expense"
                      dataKey="Expense"
                      fill="#6366f1"
                      barSize={open ? 24 : 14}
                      radius={[4, 4, 0, 0]}
                      label={{
                        position: "top",
                        fontSize: open ? 14 : 10,
                        fill: "#334155",
                        fontWeight: 600,
                        formatter: (v) => v >= 1000 ? `${(v / 1000).toFixed(1)}k` : v
                      }}
                    />

                    {/* PERCENTAGE BAR */}
                    <Bar
                      yAxisId="percentage"
                      dataKey="Percentage"
                      fill="#f59e0b"
                      barSize={open ? 24 : 14}
                      radius={[4, 4, 0, 0]}
                      label={{ position: "top", fontSize: open ? 14 : 10, fill: "#475569", fontWeight: 600 }}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </Box>
            </Box>
          ) : (
            <Box sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              color: "#475569",
              gap: 1
            }}>
              <PieChartOutlineIcon sx={{ fontSize: 40, opacity: 0.5 }} />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                No data found
              </Typography>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  )
}

export default ExpenseDashboard
